/**
 * Helper funkcie pre prácu s localStorage pre PharmacologicalPlan
 */

const STORAGE_PREFIX = "pharma_plan_";
const TTL_MS = 5 * 60 * 1000; // 5 minút

/**
 * Uloží dáta do localStorage
 * @param {string} key - Kľúč pre uloženie
 * @param {object} data - Dáta na uloženie
 */
export const saveToLocalStorage = (key, data) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    localStorage.setItem(storageKey, JSON.stringify({ data, savedAt: Date.now() }));
  } catch (error) {
    console.error("Error saving to localStorage:", error);
  }
};

/**
 * Načíta dáta z localStorage
 * @param {string} key - Kľúč pre načítanie
 * @returns {object|null} - Načítané dáta alebo null
 */
export const loadFromLocalStorage = (key) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt) return parsed; // starý formát bez TTL
    if (Date.now() - parsed.savedAt > TTL_MS) {
      localStorage.removeItem(storageKey);
      return null;
    }
    return parsed.data;
  } catch (error) {
    console.error("Error loading from localStorage:", error);
    return null;
  }
};

/**
 * Vymaže dáta z localStorage
 * @param {string} key - Kľúč pre vymazanie
 */
export const removeFromLocalStorage = (key) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.error("Error removing from localStorage:", error);
  }
};

/**
 * Vymaže všetky dáta súvisiace s PharmacologicalPlan
 * @param {string} planId - ID plánu
 */
export const clearAllPharmaPlanData = (planId) => {
  try {
    const keys = [
      `${planId}_main`,
      `${planId}_verification`,
      `${planId}_recommendation`,
      `${planId}_discharge`,
      `${planId}_evaluation`,
      `${planId}_condition_change`,
    ];

    keys.forEach((key) => removeFromLocalStorage(key));
  } catch (error) {
    console.error("Error clearing pharma plan data:", error);
  }
};

/**
 * Vytvorí debounced funkciu pre ukladanie
 * @param {Function} func - Funkcia na debounce
 * @param {number} delay - Delay v ms
 * @returns {Function} - Debounced funkcia
 */
export const debounce = (func, delay = 1000) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};
